export class PropertySearcher {
  static findValue(object, key) {
    let value;
    Object.keys(object).some(function(k) {
        if (k === key) {
            value = object[k];
            return true;
        }
        if (object[k] && typeof object[k] === 'object') {
            value = PropertySearcher.findValue(object[k], key);
            return value !== undefined;
        }
    });
    return value;
  }
}
